import { IsEnum, IsNotEmpty, IsOptional, IsString, ValidateIf } from 'class-validator';

import { FieldStringFormatType } from './field-string-format-type';

/**
 * @see backend-php/modules/rest_common/models/taxonomy/FieldString.php
 */
export class FieldStringOptions {
    @IsOptional()
    @IsString()
    public format: string;

    // тип проверки
    @ValidateIf((o: FieldStringOptions) => !!o.formatType || !!o.format)
    @IsNotEmpty()
    @IsEnum(FieldStringFormatType, { message: 'formatType неизвестный тип формата поля таксономии' })
    public formatType: FieldStringFormatType;

    constructor(data?: Partial<FieldStringOptions>) {
        this.format = data?.format;
        this.formatType = data?.formatType;
    }
}
